import './Slotter.scss';
import React from 'react';

import {
  useWindowWidth,
} from '@react-hook/window-size'


function Slotter({ children, className, slotterSize, minWidth, gap }) {

  const windowWidth = useWindowWidth()
  
  if (isNaN(slotterSize)) {
    slotterSize = children.reduce((acc, cur) => {    
      return acc + (Number(cur.props.slotSize) || 1)
    }, 0)
  }

  return (
    <div className={'slotter' + (className ? ` ${className}` : '') + (gap ? ` gap-${gap}` : '')}>
      { React.Children.toArray(children).map((item, index) => {
        let slotSize = item.props.slotSize || 1

        if (minWidth && windowWidth < minWidth) {
          slotSize = 1
          slotterSize = 1
        }

        return (
          <Slot key={index} slotSize={slotSize} slotterSize={slotterSize} >
            { item }
          </Slot>    
        )
      }) }            
    </div>
  );
}

export default Slotter;

export function Slot({ children, className, slotSize = 1, slotterSize }) {
  return (
    <div className={'slot' + (className ? ` ${className}` : '')} style={{ width: `${( 100 * (slotSize / slotterSize) )}%` }} >
      { children }
    </div>
  );
}
